module.exports = __webpack_public_path__ + "img/logo_cafam@2x.3f820a69.png";